// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import router from './router'

import Vue from 'vue';
import Vuex from 'vuex';
import ElementUI, { MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import axios from 'axios';

import VueHighCharts from 'vue-highcharts';
import Highcharts from 'highcharts/highstock';
import loadExporting from 'highcharts/modules/exporting';
import promise from 'es6-promise';
import 'lib-flexible/flexible.js';

import VCharts from 'v-charts'
import vueHighcharts from 'vue-highcharts';
loadExporting(Highcharts);

Vue.use(VCharts)
Vue.use(VueHighCharts, {Highcharts});

//兼容IE、360浏览器等
promise.polyfill();

Vue.prototype.$axios = axios
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.config.productionTip = false

//Highcharts设置
Highcharts.setOptions({
  global: {
    useUTC: false
  },
  navigation: {
    menuItemStyle: {
      padding: '6px 14px'
    }
  },
})

//在路由条状前判断是否有跳转权限，没有则转到主页
// router.beforeEach(({name}, from, next) => {
//   if (name !== 'Operation Status') {
//     console.log("跳转其他页面")
//     axios.post(Vue.prototype.urlFragment + '/account/test')
//       .then(function (response) {
//         console.log(response)
//         if(response.status){
//           console.log("存在status")
//           next()
//         }else {
//           next({name: 'Operation Status'})
//         }
//       }).catch(error => {
//       console.log("出错")
//       next({name: 'Operation Status'})
//     })
//   } else {
//     console.log("直接跳转")
//     next()
//   }
// })

axios.defaults.timeout = '500000000'   //连接超时时间npn
// axios.defaults.baseURL="http://192.168.113.35:80"
//axios.defaults.baseURL="http://210.45.77.114:80"
// axios.defaults.baseURL="http://222.195.82.88:8090"     //默认URL
Vue.prototype.urlFragment ="/data";
//axios.defaults.headers.post['Content-Type'] = 'application/json'  //编码格式
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'  //编码格式
axios.defaults.headers['Access-Control-Allow-Origin'] = '*'  //编码格式

//axios 请求和响应拦截器
axios.interceptors.request.use(
  config => {
    if (window.sessionStorage.JWT_TOKEN) {    //判断sessionStorage中是否有token
      config.headers.Authorization = `${window.sessionStorage.JWT_TOKEN}` //将token加入请求头
      //config.headers.Cookie = `JSESSIONID=${window.sessionStorage.JWT_TOKEN}` //将token加入请求头
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// 是否正在显示登录提示框（防止重复弹窗）
let isShowingLoginAlert = false

axios.interceptors.response.use(
  response => {
    //将接收到的新的token存入sessionStorage中
    if (response.headers.newtoken) {
      window.sessionStorage.setItem('JWT_TOKEN', response.headers.newtoken)
    }

    // 检查响应数据中的code，判断是否需要重新登录
    if (response.data && response.data.code === -1) {
      if (!isShowingLoginAlert) {
        isShowingLoginAlert = true
        MessageBox.alert('登录已过期，请重新登录','提示',{
          confirmButtonText:'确定',
          callback:action =>{
            isShowingLoginAlert = false
            // 清除sessionStorage
            window.sessionStorage.removeItem('JWT_TOKEN')
            window.sessionStorage.removeItem('USER_NAME')
            window.sessionStorage.removeItem('USER_TYPE')
            window.sessionStorage.removeItem('isManage')

            // 跳转到首页并显示登录对话框
            router.replace({
              path:'/home'
            })
            // 刷新页面以触发登录对话框
            window.location.reload()
          }
        })
      }
      return Promise.reject(new Error('需要重新登录'))
    }

    return response
  }, function (err) {
    // 处理错误响应（401/403状态码）
    if(err.response && (err.response.status == 401 || err.response.status == 403)){
      if (!isShowingLoginAlert) {
        isShowingLoginAlert = true
        MessageBox.alert('登录已过期，请重新登录','提示',{
          confirmButtonText:'确定',
          callback:action =>{
            isShowingLoginAlert = false
            // 清除sessionStorage
            window.sessionStorage.removeItem('JWT_TOKEN')
            window.sessionStorage.removeItem('USER_NAME')
            window.sessionStorage.removeItem('USER_TYPE')
            window.sessionStorage.removeItem('isManage')

            // 跳转到首页并显示登录对话框
            router.replace({
              path:'/home'
            })
            // 刷新页面以触发登录对话框
            window.location.reload()
          }
        })
      }
    }
    //此处只能接收到，错误信息，不能解析错误的状态码
    return Promise.reject(err);
  })



// 日期格式转化方法
Date.prototype.format = function(fmt) {
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds() < 100 ?  '0' + this.getMilliseconds().toString() :  this.getMilliseconds()       //毫秒
  };
  if(/(y+)/.test(fmt)) {
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  }
  for(var k in o) {
    if(new RegExp("("+ k +")").test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    }
  }
  return fmt;
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js